// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-sitemap_import-sitemap_import_error_dialog__supportLink {\n  color: #000000;\n}\n", "",{"version":3,"sources":["webpack://./src/sitemap_import/sitemap_import_error_dialog.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","sourcesContent":[".supportLink {\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"supportLink": "src-sitemap_import-sitemap_import_error_dialog__supportLink"
};
export default ___CSS_LOADER_EXPORT___;
